"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropDownAnimationWithLoading = exports.dropDownAnimation = void 0;
exports.dropDownAnimation = {
    initial: { height: 0, opacity: 0 },
    animateOptions: { height: 'auto', maxHeight: 150, opacity: 1 },
    exit: { height: 0, opacity: 0 },
};
exports.dropDownAnimationWithLoading = __assign(__assign({}, exports.dropDownAnimation), { animateOptionsLoading: { height: 50, maxHeight: 150, opacity: 1 } });
